import React, {useState} from 'react';
import styles from './details-sidebar.module.scss';
import {Link} from "react-router-dom";
import ShareButton from "@/components/global/share-button";
import {useDispatch} from "react-redux";
import {like} from "@/actions/post";

type Props = {
  post: IPostDetails | null | undefined
};

const PostDetailsSidebar: React.FC<Props> = ({ post }) => {
  const [liked, setLiked] = useState<boolean>(post?.likedByViewer || false);
  const [likes, setLikes] = useState<number>(post?.likes || 0);
  const dispatch = useDispatch();

  const postLikeChange = (newState: boolean) => {
    like(post?.id || 0, newState)(dispatch).then((props: any) => {
      setLikes(props.likes);
      setLiked(newState);
    });
  }
  
  return (
    <div className={styles.postDetailsSidebar}>
      <div className={styles.detailSection}>
        <div className={styles.imageContainer}>
          {post ? (
              <img src={post.image || '//placehold.it/400x400'} alt={post.title || 'Loading...'} />
          ) : (
              <div className={styles.loadingImage} />
          )}
        </div>
        <div className={styles.title}>
          <h3>{post?.title || 'در حال بارگزاری...'}</h3>
          <div className={styles.buttonContainer}>
            <ShareButton postId={post?.id} />
            <button type="button" onClick={() => postLikeChange(!liked)}>
              {liked ? (
                  <i className={"fas fa-heart " + styles.liked} />
              ) : (
                  <i className="far fa-heart" />
              )}
            </button>
            <span className={styles.likeCount}>
            {likes || 0}
          </span>
          </div>
        </div>
      </div>
      <div className={styles.detailSection}>
        <h5>اطلاعات کلی</h5>
        <div className={styles.infoContainer}>
          <div className={styles.infoItem}>
            <strong>منتشر کننده</strong>
            <span>
              <Link to={`/artist/${post?.artist.id}`}>
                {post?.artist.hasBadge ? <i className="fas fa-badge-check" /> : ''}
                {' '}
                {post?.artist.name}
              </Link>
            </span>
          </div>
          <div className={styles.infoItem}>
            <strong>محتوا</strong>
            <span>
              {post?.categories.map((cat, i) => (
                  <Link to={`/${cat.slug}`} key={'category' + cat.slug + Math.random()}>{cat.category}</Link>
              ))}
            </span>
          </div>
          <div className={styles.infoItem}>
            <strong>تعداد بازدید</strong>
            <span>
              {post?.views}
            </span>
          </div>
          <div className={styles.infoItem}>
            <strong>تاریخ انتشار</strong>
            <span>
              {post?.date}
            </span>
          </div>
        </div>
      </div>
      <div className={styles.detailSection}>
        <h5>برچسب ها</h5>
        <div className={styles.tagsContainer}>
          {post?.tags.map((tag, i) => (
              <Link key={'tag-' + tag.slug + Math.random()} to={`/posts?tag=${tag.slug}`} className={styles.tagItem}>
                {tag.title}
              </Link>
          ))}
        </div>
      </div>
      <div className={styles.detailSection}>
        <h5>دسته بندی ها</h5>
        <div className={styles.tagsContainer}>
          {post?.subcategories.map((cat, i) => (
              <Link key={'cat-' + cat.slug + Math.random()} to={`/posts/${cat.slug}`} className={styles.tagItem}>
                {cat.category}
              </Link>
          ))}
        </div>
      </div>
    </div>
  );
}

export default PostDetailsSidebar;
